import { render } from "./RoomsPage.vue?vue&type=template&id=2775d176"
import script from "./RoomsPage.vue?vue&type=script&lang=js"
export * from "./RoomsPage.vue?vue&type=script&lang=js"

import "./RoomsPage.vue?vue&type=style&index=0&id=2775d176&lang=scss"

import exportComponent from "C:\\Users\\Ollie\\Apps\\lasource-hautesalpes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__